// extracted by mini-css-extract-plugin
export default {"carousel":"TemplatePreview_carousel__V9T6w"};